<template>
  <div>
    <PromptControl
      @ok="ok"
      @cancel="cancel"
      @closed="closed"
      v-bind:show="show"
      v-bind:title="lang('lbl_0000056')"
      v-bind:message="lang('lbl_0000057')"
    />
    <ContentWrapperControl>
      <div
        v-show="verify"
        class="bg-white p-4 rounded-b-lg shadow overflow-hidden"
      >
        <div
          v-text="lang('lbl_0000076')"
          class="text-sm leading-normal text-grey-darkest"
        ></div>
      </div>
      <div class="bg-white p-4 mt-4 rounded-lg shadow">
        <div v-show="!verify">
          <div class="mb-3">
            <TextControl
              @typing="typing"
              @is-valid="is_valid = $event"
              v-bind:value="value"
              name="email"
              type="email"
              :registration="false"
            />
          </div>
          <div>
            <ButtonControl v-on:click="update" v-bind:disabled="!is_valid">
              {{ lang("lbl_0000033") }}
            </ButtonControl>
          </div>
        </div>
        <div v-show="verify">
          <OTPControl
            @success="success"
            @failed="failed"
            @showloader="showloader"
            @hideloader="hideloader"
            v-bind:type="otp.type"
            v-bind:pin="otp.pin"
            v-bind:email="value"
            v-bind:name="name"
          />
        </div>
      </div>
      <PrivacyInfoControl v-show="!verify" />
    </ContentWrapperControl>
    <div v-show="verify" class="pt-2 flex justify-center items-center pb-6">
      <div
        v-on:click="editEmail"
        v-text="lang('lbl_0000292')"
        class="text-sm leading-none underline text-grey-darker font-semibold"
      ></div>
    </div>
  </div>
</template>

<script>
import { onBeforeRouteLeave } from "vue-router";
import ButtonControl from "./../../components/controls/ButtonControl.vue";
import ContentWrapperControl from "./../../components/controls/ContentWrapperControl.vue";
import PrivacyInfoControl from "@/components/controls/PrivacyInfoControl.vue";
import OTPControl from "./../../components/controls/OTPControl.vue";
import PromptControl from "./../../components/controls/PromptControl.vue";
import TextControl from "./../../components/controls/TextControl.vue";
import User from "./../../services/User.js";
import mixin from "./../../mixin.js";
import OTP from "@/services/OTP";

export default {
  mixins: [mixin],
  components: {
    ButtonControl,
    ContentWrapperControl,
    OTPControl,
    PromptControl,
    TextControl,
    PrivacyInfoControl,
  },
  data() {
    return {
      value: null,
      is_valid: false,
      verify: false,
      saving: false,
      changed: false,
      show: false,
      name: null,
      href: null,
      hash: null,
      otp: {
        type: 6,
        token: null,
        pin: null,
      },
    };
  },
  mounted() {
    this.$emit("checkauth", false);
    this.$emit("nofooter", true);
    this.$emit("shownavbar", {
      title: this.lang("lbl_0000268"),
      show: true,
      back: true,
    });

    let state = this.$store.state;
    this.value = state.enroll.email;
    this.name = this.$store.state.info.first_name || "";

    onBeforeRouteLeave((to) => {
      this.href = to.fullPath;
    });
  },
  watch: {
    value(new_value) {
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      this.is_valid = regex.test(new_value);
    },
  },
  methods: {
    reset() {
      this.saving = false;
      this.verify = false;
      this.disabled = true;
      this.hash = null;
      this.otp.token = null;
      this.otp.pin = null;
    },
    success(data) {
      let state = this.$store.state;

      this.saving = true;
      this.otp.token = data.otp_token;
      this.$emit("showloader");
      User.updateEmail(state.uuid, {
        value: this.value,
        otp_token: this.otp.token,
        otp_pin: this.otp.pin,
        update_key: this.hash,
      })
        .then(() => {
          state.info.email = this.value;
          state.enroll.email = null;
          state.otp_login = true;
          this.makeOTPLoginCookie(state.hash);
          this.$emit("success", this.lang("lbl_0000279"));

          if (!state.info.mobile_no) {
            this.$router.push("/user/info/checklist");
            return;
          }

          if (
            state.login &&
            state.has_pin &&
            !state.pin_login &&
            (!state.config.status || (state.config.status && state.otp_login))
          ) {
            this.$router.push("/");
            return;
          }

          if (state.login && !state.has_pin) {
            this.$router.push("/user/enroll/pin");
            return;
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        }).finally(() => {
          this.reset();
        });
    },
    failed(message) {
      this.$emit("alert", {
        theme: "error",
        title: this.lang("lbl_0000034"),
        message: message,
      });
    },
    
    ok() {
      this.changed = false;
      this.$router.push(this.href);
    },
    closed() {
      this.show = false;
    },
    cancel() {
      this.show = false;
    },
    typing(obj) {
      let state = this.$store.state;
      this.value = obj.value;
      // state.info.email = this.value;
      state.enroll.email = this.value;
    },
    update() {
      let state = this.$store.state;

      this.$emit("showloader");
      User.validateEmail(state.uuid, this.value)
        .then((response) => {
          let data = response.data.data;

          this.hash = data.hash;
          this.otp.type = data.type;
          this.otp.pin = data.pin;
          this.requestOTP();
        })
        .catch((error) => {
          this.hash = null;
          this.otp.type = null;
          this.otp.pin = null;
          this.verify = false;
          this.$emit("error", error);
        });
    },
    showloader() {
      this.$emit("showloader");
    },
    hideloader() {
      if (!this.saving) {
        this.$emit("hideloader");
      }
    },
    requestOTP() {
      let state = this.$store.state;

      this.$emit("showloader");
      OTP.request(
        this.otp.type,
        state.info.first_name,
        this.value,
        null,
        this.otp.pin
      )
        .then(() => {
          this.$emit("shownavbar", {
            title: this.lang("lbl_0000268"),
            show: true,
            back: false,
          });
          this.verify = true;
        })
        .catch((error) => {
          this.$emit("failed", error.response.data.message);
        })
        .finally(() => {
          this.$emit("hideloader");
        });
    },
    editEmail() {
      this.$emit("shownavbar", {
        title: this.lang("lbl_0000268"),
        show: true,
        back: true,
      });
      this.verify = false;
    },
  },
};
</script>
